import {createFormContext} from '@mantine/form';
import type {z} from 'zod';
import type {HashTagSchema} from '../../../core/entities/mypage/schema';

type hashtagType = z.infer<typeof HashTagSchema>;

export type DevelopmentExperiencesValues = {
  experiences: Array<{
    id?: number;
    categoryTag: hashtagType;
    body: string;
    startDate: string;
    endDate: string;
    programmingLanguageTags: hashtagType[];
    libraryFrameworkTags: hashtagType[];
    otherTags: hashtagType[];
  }>;
};

export const [
  DevelopmentExperiencesFormProvider,
  useDevelopmentExperiencesFormContext,
  useDevelopmentExperiencesForm,
] = createFormContext<DevelopmentExperiencesValues>();
